import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject } from '@angular/core';
import { Territory, TerritoryDTO } from '../../../../core/models/territory.interface';
import {
  OptionSelect,
  SearchSelect,
} from '../../../../shared/components/search-select/search-select';
import { LifePlan } from '../../../../core/models/lifeplan.interface';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { LoadingService } from '../../../../core/services/loading/loading';
import { TerritoryService } from '../../../../core/services/territory/territory';
import { LifeplanService } from '../../../../core/services/lifeplan/lifeplan';
import { FormUtils } from '../../../../shared/utils';
import { switchMap } from 'rxjs';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatIcon, MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-territory-form',
  imports: [
    MatFormField,
    ReactiveFormsModule,
    MatLabel,
    MatInput,
    MatError,
    MatIcon,
    MatIconModule,
    FormsModule,
    SearchSelect,
  ],
  templateUrl: './territory-form.html',
  styleUrl: './territory-form.scss',
})
export class TerritoryForm {
  sector: string | null = null;
  errorMsg: string[] | null = null;
  territorySelected: Territory | null = null;
  lifeplanSelected: OptionSelect[] = [];
  listLifeplans: LifePlan[] = [];
  selectLifeplan: OptionSelect | null = null;
  lifeplanSeleccionado: LifePlan | null = null;
  private formBuilder = inject(FormBuilder);

  constructor(
    private dialogRef: MatDialogRef<TerritoryForm>,
    private toastr: ToastrService,
    private serviceTerritory: TerritoryService,
    private loadingService: LoadingService,
    private lifeplanService: LifeplanService,
  ) {}

  ngOnInit(): void {
    this.fetchTerritory();
    this.serviceTerritory.asyncErrorValidation$.subscribe((error) => {
      if (error) {
        this.errorMsg = FormUtils.parseErrorMsgs(error);
      }
    });
  }

  private fetchTerritory() {
    this.lifeplanService
      .getLifeplans()
      .pipe(
        switchMap((lifeplans) => {
          this.listLifeplans = lifeplans;
          this.lifeplanSelected = this.lifeplanService.getOptionLifeplan(lifeplans);
          return this.serviceTerritory.selectedterritory$;
        }),
      )
      .subscribe((territory) => {
        if (territory) {
          this.territorySelected = territory;
          this.territoryForm.patchValue({
            ...this.territorySelected,
            lifePlan: this.territorySelected?.lifePlan?.id || 0,
          });
          const lifeplanOpt = this.lifeplanSelected.find((el) => {
            if (this.territorySelected) {
              return el.value === this.territorySelected.lifePlan?.id;
            }
            return false;
          });
          if (typeof lifeplanOpt !== 'undefined') {
            this.selectLifeplan = lifeplanOpt;
          }
        }
      });
  }

  territoryForm = this.formBuilder.group({
    name: ['', [Validators.required, Validators.maxLength(256)]],
    nit: ['', [Validators.required, Validators.maxLength(256)]],
    zone: ['', [Validators.required, Validators.maxLength(256)]],
    resolution: ['', [Validators.maxLength(256)]],
    legalRepresentation: ['', [Validators.maxLength(256)]],
    lifePlan: [0, [Validators.required]],
  });

  getLifeplan(id: number) {
    const index = this.listLifeplans.findIndex((lifeplan) => lifeplan.id === id);
    this.lifeplanSeleccionado = this.listLifeplans[index];
  }

  onLifeplanSelected(lifeplan: OptionSelect) {
    this.territoryForm.get('lifePlan')?.setValue(lifeplan.value as number);
    this.getLifeplan(lifeplan.value as number);
  }

  closeDialog() {
    this.dialogRef.close();
  }

  saveTerritory() {
    const payload = this.territoryForm.value as TerritoryDTO;
    if (this.territoryForm.status === 'VALID' && !this.sector) {
      this.loadingService.show(true);
      this.serviceTerritory.createTerritory(payload).subscribe({
        next: (territory) => {
          this.loadingService.show(false);
          const msg = `El territorio ${territory.name} fue CREADO correctamente!`;
          this.toastr.success(msg, 'Exitoso!', {
            progressBar: true,
            timeOut: 5000,
          });
          this.dialogRef.close();
        },
        error: ({}: HttpErrorResponse) => {
          if (this.errorMsg) {
            this.loadingService.show(false);
            this.toastr.error('Error: ' + this.errorMsg, undefined, {
              progressBar: true,
              timeOut: 5000,
            });
          }
        },
      });
    } else if (this.territoryForm.status === 'VALID' && this.sector) {
      this.loadingService.show(true);
      const id = Number(this.sector);
      this.serviceTerritory.UpdateTerritory(id, { ...payload, id: id }).subscribe({
        next: (territory) => {
          this.loadingService.show(false);
          const msg = `El territorio ${territory.name} fue EDITADO correctamente!`;
          this.toastr.success(msg, 'Exitoso!', {
            progressBar: true,
            timeOut: 5000,
          });
          this.dialogRef.close();
        },
        error: ({}: HttpErrorResponse) => {
          if (this.errorMsg) {
            this.loadingService.show(false);
            this.toastr.error('Error: ' + this.errorMsg, undefined, {
              progressBar: true,
              timeOut: 5000,
            });
          }
        },
      });
    }
  }
  getLifeplanValue() {
    return this.selectLifeplan;
  }
}
